export * from './app-sidebar-nav.component';



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/components/app-sidebar-nav/index.ts